export default {
  methods: {
    // TODO: Add functionality to add properties to error messages
    validate(validationObject, validator) {
      function check(exception, key) {
        if (!exception.validator) {
          console.error('Missing validator on', key);

          return {};
        }
        if (exception.validator()) {
          return {
            value: true,
          };
        }
        validationObject[key].error = exception.error;
        return {
          value: false,
          error: exception.error,
        };
      }

      const values = Object.entries(validator).map(([key, value]) => {
        if (Array.isArray(value)) {
          const errorQueue = _.compact(value.map((exception) => (check(exception, key).value === false ? check(exception, key).error : null)));

          validationObject[key].error = errorQueue[0];

          return !(errorQueue.length > 0);
        }
        return check(value, key).value;
      });

      if (!values.includes(false)) {
        return true;
      }
      return false;
    },
    setErrors(errors) {
      Object.entries(errors).forEach(([key, error]) => {
        let path = null;
        if (key.includes('.')) {
          path = key.split('.');
        }

        if (path !== null && this.form[path[0]] instanceof Object) {
          function setToValue(obj, value, path) {
            let i;
            path = path.split('.');

            for (i = 0; i < path.length - 1; i++) obj = obj[path[i]];

            if (typeof obj[path[i]] !== 'undefined') {
              obj[path[i]].error = value;
            }
          }

          const name = path[0];
          path.splice(0, 1);

          if (typeof this.form[path[0]] !== 'undefined' && typeof this.form[path[0]].value === 'undefined') {
            path = `${name}.${path.join('.')}`;
          } else {
            path = `${name}.value.${path.join('.')}`;
          }

          setToValue(this.form, error[0], path);
        } else {
          this.form[key].error = error[0];
        }
      });
    },
  },
};
